import { useEffect } from 'react';
import { useElementIsVisible } from './useElementIsVisible';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
export const useProductGroupAnalytics = (isEnabled, target, componentName, componentType, products = []) => {
    const type = componentType || 'none';
    const isVisible = useElementIsVisible(target);
    const dispatch = useDispatch();
    useEffect(() => {
        if (isEnabled && isVisible) {
            dispatch(analyticsActions.productGroupViewed({ componentName, componentType: type, products }));
        }
    }, [isVisible]);
    const handleItemClickAnalytics = (productTilePosition, product) => {
        if (isEnabled) {
            dispatch(analyticsActions.productGroupItemClick({
                componentName,
                componentType: type,
                productTilePosition,
                product,
            }));
        }
    };
    const getProductGroupAnalyticsData = (productTilePosition) => isEnabled
        ? {
            componentName,
            componentType: type,
            productTilePosition,
        }
        : undefined;
    return { handleItemClickAnalytics, getProductGroupAnalyticsData };
};
